import { motion } from "framer-motion";
import { Star, BadgeCheck } from "lucide-react";

const REVIEWS = [
  {
    name: "Emily R.",
    place: "Florida, USA",
    initials: "ER",
    quote:
      "The recipes are amazing and easy to make. I feel lighter, more energized — and now tea is part of my daily routine!",
  },
  {
    name: "Michael T.",
    place: "Texas, USA",
    initials: "MT",
    quote:
      "This guide is practical, complete and easy to follow. I love that I can create my own blends based on what I like and need.",
  },
  {
    name: "Jessica L.",
    place: "California, USA",
    initials: "JL",
    quote:
      "It's not just about tea — it's about building better habits. This changed the way I take care of my health.",
  },
];

export default function Testimonials() {
  return (
    <section id="reviews" className="py-16 sm:py-24 lg:py-32" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="text-center max-w-2xl mx-auto mb-14"
        >
          <p className="text-xs sm:text-sm font-bold tracking-[0.24em] uppercase text-[#D4A359] mb-4">
            Loved by readers
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#1A241E] leading-tight" data-testid="reviews-heading">
            Real routines. Real people.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8" data-testid="reviews-grid">
          {REVIEWS.map((r, i) => (
            <motion.figure
              key={r.name}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.14, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -6 }}
              className="bg-white rounded-2xl border border-[#1C3A27]/10 p-7 sm:p-8 shadow-[0_10px_30px_-18px_rgba(18,38,26,0.25)] transition-shadow duration-500 hover:shadow-[0_24px_50px_-20px_rgba(18,38,26,0.35)]"
              data-testid={`review-card-${i}`}
            >
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-[#D4A359] text-[#D4A359]" />
                ))}
              </div>
              <blockquote className="font-display text-lg sm:text-xl leading-relaxed text-[#1A241E] italic">
                "{r.quote}"
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <span className="w-11 h-11 rounded-full bg-[#1C3A27] text-[#D4A359] font-display font-bold flex items-center justify-center text-sm">
                  {r.initials}
                </span>
                <div>
                  <p className="text-sm font-bold text-[#1A241E] flex items-center gap-1.5">
                    {r.name}
                    <BadgeCheck className="w-4 h-4 text-[#1C3A27]" />
                  </p>
                  <p className="text-xs text-[#5C6A60]">{r.place} · Verified reader</p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
